require('./setup/events');
require('./setup/prototypes');
require('./setup/initializeObservers');
require('./setup/globals');
require('./managers/tiptap');

// Инициализация TabIdManager
window.tabIdManager = new TabIdManager();